import { LocaleProvider } from 'antd';
import { browserHistory, Route, Router, IndexRoute } from "react-router";
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import React from 'react';
import ReactDOM from 'react-dom';
import './resolveConfig.js'
// import ReactDOMServer from 'react-dom/server';
import 'rt-sd-common/sgiCommon/sgiRunningCommon';
// import 'rt-sd-comp/sgiComp/SgiCompComm';
import './conf/sgiFunction';
import './conf/sgiConfig';
import './conf/sgiCustomModule';
// 引入cfca  api挂载window
import './cfca/index'
import { verifyCertificate } from './cfca/action';

import routes from "./routes";
if (!window.sgiSrvUrl.openLog) {
    // 关闭log
    tool.sgiLogger.Level = {};
}
// // 暴露方法到全局对象
// window.parentMethod = () => {
//     return new Promise((resolve) => {
//       verifyCertificate((res) => {
//         if (res.errorcode === '0') {
//           resolve(true); // 验证成功返回true
//         } else {
//           tool.popMessage(res.result, 'error');
//           resolve(false); // 验证失败返回false
//         }
//       });
//     });
//   };
// 暴露消息监听器
window.addEventListener("message", async (event) => {
  // 同域名可跳过严格origin校验，但建议保留
  if (event.origin !== window.location.origin) return;

  if (event.data === "REQUEST_UKY_VERIFY") {
    try {
        const res = await new Promise((resolve, reject) => {
            verifyCertificate()
                .then(resolve)
                .catch(reject); // 显式连接reject
        });
        console.log('返回校验结果',res)
        // 返回结果给子窗口
        event.source.postMessage({
            type: "UKY_RESULT",
            valid: res.errorcode === '0',
            message: tool.getCookie("currentSerialNo")
        }, event.origin);
      
    } catch (error) {
      console.error('Ukey验证错误:', error,tool.getCookie("currentSerialNo"));
      event.source.postMessage({
        type: "UKY_ERROR",
        error: error.result
      }, event.origin);
    }
  }
});
// 查看卸载-加载时间差，判断是否重新加载
let unload_time = tool.sgiStorage.get("UNLOAD_TIME");
let nowTime = new Date().getTime();
let diff = nowTime - unload_time;
tool.sgiLogger.debug('>>>>diff :', diff);
if (diff > 5 * 1000) {// 卸载时间大于3秒，删除上次登录信息
    tool.sgiLogger.debug(`>>>>diff time more than 5 seconds, will remove cookies by prefix[${sgiConfig.abb_project}]`);
    tool.removeCookieByPrefix(sgiConfig.abb_project);
}

// 初始化自定义全局方法
// apJSLoading();
// 杨某给初始化方法换登录后

// 配置初始化程序接入口-hanzb
let initGJSs = sgiConfig.initGJSs;
if (initGJSs && initGJSs.length > 0) {
    initGJSs.forEach(guid => {
        let initPrm = PrmFactory.getPrm(guid);
        if (initPrm && initPrm.guid) {
            let funanme = initPrm.c;
            let fun = initPrm.jsfun;
            let params = initPrm.params;
            if (funanme) {
                try {
                    let initFun = new Function(...(params || "").split(','), fun);
                    tool.sgiLogger.debug(`执行初始化程序[${funanme}]`);
                    initFun();
                } catch (error) {
                    tool.sgiLogger.error("初始化程序错误，请检查！", error)
                }
            }
        }
    });
}

// Client render (optional):
if (typeof document !== 'undefined') {
    const outlet = document.getElementById('app');
    // let Holder;
    window.addEventListener('DOMContentLoaded', () => {

    });

    // var _beforeUnload_time = 0, _gap_time = 0;
    // window.addEventListener("beforeunload", (event) => {
    //     _beforeUnload_time = new Date().getTime();
    // });
    window.addEventListener("unload", () => {
        // _gap_time = new Date().getTime() - _beforeUnload_time;
        // tool.sgiStorage.set("_gap_time", _gap_time);
        // if (_gap_time < 10) {
        // 认为页面关闭
        // 清除页面storage缓存
        tool.sgiStorage.removeByPrefix(sgiConfig.keyPre_app);
        // } else {
        // 认为页面刷新
        // }

        // 记录unload时间
        tool.sgiStorage.set("UNLOAD_TIME", new Date().getTime());
    });

    //禁用右键
    document.oncontextmenu = function () {
        return false;
    }

    

    ReactDOM.render(
            <LocaleProvider locale={zh_CN}>
                <Router
                    history={browserHistory}
                    routes={routes}
                />
            </LocaleProvider>,
            outlet
    );
}




// WEBPACK FOOTER //
// ./apps/app.js